export default __webpack_public_path__ + "static/media/logoNew.b56df1f2.png";